
import homePage from '@/components/homePage/index.vue';

export default {
  path: "/supplierInfo",
  component: homePage,
  redirect: "/supplierInfo/index",
  meta: { title: "账号管理" },
  children: [
    {
      path: "index",
      component: () => import('@/module/supplierInfoModule/viewPage/index.vue'),
      meta: { title: "供应商信息" },
    }
  ]
}
